import Container from "@components/ui-old/container";
import Layout from "@components/layout/layout";
import ProductSingleDetails from "@components/product/product-single-details";
//import RelatedProducts from "@containers/related-products";
import Divider from "@components/ui-old/divider";
import Breadcrumb from "@components/common/breadcrumb";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSideProps } from "next";
//import { useRouter } from "next/router";
import React from "react";
import PopulerProductFeed from "@components/product/popular-product";
import { Button } from "@components/ui/button";
import Link from "next/link";
import { useTranslation } from "next-i18next";
export default function ShopPage() {
  const {
    t
  } = useTranslation('common');
  // const { query } = useRouter();
  //const currentProductId = parseInt(query.slug as string, 10);

  return <>
      <Divider className="mb-0" data-sentry-element="Divider" data-sentry-source-file="[slug].tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="[slug].tsx">
        <div className="pt-8 flex justify-between items-center">
          <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="[slug].tsx" />
          <Button variant="link" className="text-md" data-sentry-element="Button" data-sentry-source-file="[slug].tsx">
            <Link href="/e-shop" data-sentry-element="Link" data-sentry-source-file="[slug].tsx">{t('text-back-to')}</Link>
          </Button>
          </div>
        <ProductSingleDetails data-sentry-element="ProductSingleDetails" data-sentry-source-file="[slug].tsx" />
        {/* <RelatedProducts sectionHeading="text-related-products" currentProductId={currentProductId} /> */}
        <PopulerProductFeed limit={4} data-sentry-element="PopulerProductFeed" data-sentry-source-file="[slug].tsx" />
      </Container>
    </>;
}
ShopPage.Layout = Layout;
export const getServerSideProps: GetServerSideProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common", "forms", "menu", "footer", 'swal']))
    }
  };
};